import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "input-screen-page-wrapper",
      staticStyle: { width: "100%", height: "100%" },
    },
    [
      _c("inputs-grid", {
        ref: "inputsGrid",
        attrs: {
          "additional-columns": _vm.additionalColumns,
          "column-validations": _vm.columnValidations,
          "additional-grid-options": _vm.additionalGridOptions,
          "save-changes": _vm.saveChanges,
          "export-action": _vm.downloadEngineInputs,
          "is-exporting": _vm.downloading,
          "route-suffix": "engine",
        },
        scopedSlots: _vm._u([
          {
            key: "buttons",
            fn: function () {
              return [
                !_vm.isSelectedWorkpackageMaster
                  ? _c(
                      "feature-toggle",
                      { attrs: { toggle: _vm.enableMarginInitialisation } },
                      [
                        _c("div", { staticClass: "workflow-controls" }, [
                          _c(
                            "div",
                            { staticClass: "d-flex workflow-buttons" },
                            [
                              _c(
                                VMenu,
                                {
                                  attrs: { "offset-y": "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "primary",
                                                    loading:
                                                      _vm.runningMarginInitialisation,
                                                    depressed: "",
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "actions.initialiseMargin"
                                                      )
                                                    ) +
                                                    "\n                  "
                                                ),
                                                _c(VIcon, [
                                                  _vm._v("mdi-chevron-down"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2462633125
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    VList,
                                    [
                                      _c(
                                        VListItem,
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.runMarginInitialisation(
                                                true
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(VListItemTitle, [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "actions.initialiseMarginWithDelta"
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        VListItem,
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.runMarginInitialisation(
                                                false
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(VListItemTitle, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "actions.initialiseMarginWithoutDelta"
                                                )
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "workflow-info-row" },
                            [
                              _c("last-triggered-info", {
                                staticClass: "mr-0",
                                attrs: {
                                  "last-triggered-info": _vm.lastTriggeredInfo,
                                  loading: _vm.isLastTriggeredLoading,
                                  "translation-time-key":
                                    "engineInputs.editor.initialisationLastRunTime",
                                  width: 200,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isSelectedWorkpackageMaster && _vm.hasAOExtracts
                  ? _c(
                      "feature-toggle",
                      { attrs: { toggle: _vm.enableAOExtracts } },
                      [
                        _c("div", { staticClass: "workflow-controls" }, [
                          _c(
                            "div",
                            { staticClass: "d-flex workflow-buttons" },
                            [
                              _c(
                                VBtn,
                                {
                                  staticClass: "pa-0",
                                  attrs: {
                                    color: "primary",
                                    small: "",
                                    depressed: "",
                                    loading: _vm.runningRefreshForecastVolume,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.isRefreshForecastDialogOpen = true
                                    },
                                  },
                                },
                                [
                                  _c(VIcon, { attrs: { small: "" } }, [
                                    _vm._v("mdi-autorenew"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "pl-1" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("actions.refreshForecastVolume")
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "workflow-info-row" },
                            [
                              _c("last-triggered-info", {
                                staticClass: "mr-0",
                                attrs: {
                                  "last-triggered-info":
                                    _vm.lastRefreshTriggeredInfo,
                                  loading: _vm.isLastRefreshTriggeredLoading,
                                  "translation-time-key":
                                    "engineInputs.editor.refreshForecastVolumeLastRunTime",
                                  width: 200,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canEditAttributes ? _c("engine-input-upload") : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("confirm-dialog", {
        attrs: {
          "is-open": _vm.isRefreshForecastDialogOpen,
          "ok-btn-text": _vm.$t("actions.yesProceed"),
        },
        on: {
          onOk: _vm.confirmRefreshForecast,
          onCancel: function ($event) {
            _vm.isRefreshForecastDialogOpen = false
          },
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$tkey("dialogs.refreshForecastConfirm")) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(_vm._s(_vm.$tkey("dialogs.areYouSureToProceed"))),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }